export default __webpack_public_path__ + "static/media/securityIconBlue.114069ee.svg";